import { render } from "./ProfileGraphPoint.vue?vue&type=template&id=85a1965e"
import script from "./ProfileGraphPoint.vue?vue&type=script&lang=js"
export * from "./ProfileGraphPoint.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__